import { Stack } from '@mui/material';
import EmailTemplatePreview from '@/pages/QuoteIntake/EmailTemplatePreview';
import PostEmailTemplatePreview from '@/pages/QuoteIntake/PostEmailTemplatePreview';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';
import IntakeEmailTemplateForm from './IntakeEmailTemplateForm';
import PostIntakeEmailTemplate from './PostIntakeEmailTemplate';

export default function IntakeEmailReminder() {
    const [formData] = useQuoteIntakeSetupStore((state) => [state.formData]);

    return (
        <Stack
            padding={3}
            spacing={3}
            sx={{
                maxHeight: 'calc(100vh - 168px)',
                overflow: 'auto',
            }}
        >
            <Stack direction="row" spacing={3}>
                <IntakeEmailTemplateForm />
                <EmailTemplatePreview
                    subject={
                        formData.step5?.isScreenTwo
                            ? formData?.step5?.reminderSubject
                            : formData?.step5?.subject
                    }
                    bodyBeforeLink={
                        formData.step5?.isScreenTwo
                            ? formData.step5?.reminderBodyBeforeLink
                            : formData.step5?.bodyBeforeLink
                    }
                    bodyAfterLink={
                        formData.step5?.isScreenTwo
                            ? formData.step5?.reminderBodyAfterLink
                            : formData.step5?.bodyAfterLink
                    }
                    signature={
                        formData.step5.isScreenTwo
                            ? formData.step5?.reminderSignatureOfEmail
                            : formData.step5?.signatureOfEmail
                    }
                />
            </Stack>
            {!formData.step5.isScreenTwo && (
                <Stack direction="row" spacing={3}>
                    <PostIntakeEmailTemplate />
                    <PostEmailTemplatePreview
                        isPostIntakeEnable={formData.step0.isPostIntakeEnable}
                        postIntakeSubject={formData.step5.postIntakeSubject}
                        textAfterSubmitIntakeForClient={
                            formData.step4.textAfterSubmitIntakeForClient
                        }
                        signature={
                            formData.step5.isScreenTwo
                                ? formData.step5.reminderSignatureOfEmail
                                : formData.step5.signatureOfEmail
                        }
                    />
                </Stack>
            )}
        </Stack>
    );
}
